

/**
 *
 * @class DistinctColorPalette
 *
 * @brief provides method for working with visually distinct colors
 *
 *   ref: https://graphicdesign.stackexchange.com/questions/3682/where-can-i-find-a-large-palette-set-of-contrasting-colors-for-coloring-many-d
 *   ref: https://mokole.com/palette.html
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class DistinctColorPalette {


  /**
   * fixed set of maximally distinct colors
   *
   * https://phrogz.net/css/distinct-colors.html
   * https://artshacker.com/wp-content/uploads/2014/12/Kellys-22-colour-chart.jpg
   * https://graphicdesign.stackexchange.com/questions/108733/how-to-get-10-different-colors-that-are-easily-recognizable
   *
   */
  public static colors: string[] = [
    '#ff8080',
    '#40ff8c',
    '#403030',
    '#ff2200',
    '#ffee00',
    '#330700',
    '#592400',
    '#b39886',
    '#e680ff',
    '#b2742d',
    '#403300',
    '#b2982d',
    '#a1f200',
    '#eaffbf',
    '#468c59',
    '#992663',
    '#0d332b',
    '#59b3ad',
    '#005c73',
    '#00aaff',
    '#bfe1ff',
    '#0066ff',
    '#265499',
    '#0d1733',
    '#bfbfff',
    '#2200ff',
    '#330080',
    '#330d2b',
    '#ff00aa',
    '#ffbfe1',
    '#992636'
  ]

  /** current position in the color array */
  public static position: number = -1;

  /** force colors to start at beginning again */
  public static reset() {

    DistinctColorPalette.position = -1;
  }

  /** fetch the next color in a fixed order */
  public static next(): string {

    DistinctColorPalette.position++;

    if (DistinctColorPalette.position > DistinctColorPalette.colors.length) {

      DistinctColorPalette.position = 0;
    }

    return DistinctColorPalette.colors[DistinctColorPalette.position];
  }

}
